import '../scss/style.scss'

console.log(
  '%c👋 Design by https://epok-design.fr & Dev by https://erichuguenin.com',
  'color: #303caaff; background: linear-gradient(90deg, #91f3a2ff, #fc99e3ff); font-weight: bold; font-size: 16px; padding: 8px 12px; border-radius: 6px;'
);


// jQuery
import jQuery from "jquery"
window.$ = window.jQuery = jQuery

// utils
import sniffer from "./base/sniffer"
import * as utils from "./base/utils"
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import sample from 'lodash/sample'
import shuffle from 'lodash/shuffle'
import random from 'lodash/random'

// gsap
//import { gsap } from "gsap"
//import { Flip } from "gsap/Flip"
//import { CustomEase } from "gsap/CustomEase"
//import { ExpoScaleEase, RoughEase, SlowMo } from "gsap/EasePack"

//import SplitText from "./libs/SplitText.min"
//import gsap from "./libs/gsap"
//import CustomEase from "./libs/CustomEase"

import gsap from "gsap"
import SplitText from "gsap/SplitText"
import CustomEase from "gsap/CustomEase"


// bus
import emitter from './bus/emitter'
import busResize from './bus/busResize'
import busRaf from './bus/busRaf'
import busMouse from './bus/busMouse'

// base
import ajax from "./base/ajax"

// animations / page reveal / page hide
import anim from './anim/anim'
import onPageEnter from "./anim/onPageEnter"
import onPageLeave from "./anim/onPageLeave"
import preload from "./anim/preload"


// init content
import initSite from "./initSite"

// scroll stuff
import resizeContainer from './base/resizeContainer'
import scrollto from "./base/scrollto"
import prvtmouse from "./base/prvtmouse"

function app() {
  // Scroll State
  window.st = {
    current: window.scrollY,
    eased: window.scrollY,
    easedReal: window.scrollY,
    min: 0,
    max: 0
  };

  window.stx = {
    current: window.scrollX,
    eased: window.scrollX,
    easedReal: window.scrollX,
    min: 0,
    max: 0
  };

  window.deltaRatio = 1; // default value, will be erased
  window.scrollType = 'lenis'; // 'virtual' || 'lenis' || 'smooth' || 'native'

  // utils
  window.utils = window.u = utils;
  window._ = [];
  _.throttle = throttle;
  _.debounce = debounce;
  _.sample = sample;
  _.shuffle = shuffle;
  _.random = random;

  // Sniffer
  window.sniffer = sniffer;
  sniffer.init();
  window.isBasic = sniffer.isBasic = sniffer.isSimplified;
  window.isComplexe = !window.isBasic;
  if (window.isBasic) window.scrollType = 'native';

  // HTML Class Management
  const html = document.documentElement;
  html.classList.add(sniffer.isSimplified ? 's-basic' : 's-complexe');
  html.classList.add(sniffer.isMobile ? 's-mobile' : 's-desktop');
  //html.classList.add(sniffer.isIE ? 's-ie' : 's-notie');
  //html.classList.add(sniffer.isSafari ? 's-safari' : 's-notsafari');
  //html.classList.add(sniffer.isFirefox ? 's-firefox' : 's-notfirefox');

  // gsap
  window.gsap = gsap;
  gsap.config({ nullTargetWarn: false });
  gsap.registerPlugin(SplitText);
  window.SplitText = SplitText;
  gsap.registerPlugin(CustomEase);
  window.CustomEase = CustomEase;
  /*gsap.registerPlugin(Flip)
  window.Flip = Flip*/
  //window.ExpoScaleEase = ExpoScaleEase
  //window.RoughEase = RoughEase
  //window.SlowMo = SlowMo

  const $html = $('html')
  $html.addClass(sniffer.isSimplified ? 's-basic' : 's-complexe');
  $html.addClass(sniffer.isMobile ? 's-mobile' : 's-desktop');
  //$html.addClass(sniffer.isIE ? 's-ie' : 's-notie');
  //$html.addClass(sniffer.isSafari ? 's-safari' : 's-notsafari');
  //$html.addClass(sniffer.isFirefox ? 's-firefox' : 's-notfirefox');

  // Bus
  window.bus = new emitter();
  busResize();
  busRaf();
  busMouse();

  // Scroll Stuff
  resizeContainer();
  scrollto();
  prvtmouse();

  // Ajax
  ajax();

  // Animations / Reveal / Hide
  window.anim = anim;
  window.pageTransiType = false;
  onPageEnter();
  onPageLeave();

  // Init Site
  initSite();
  preload();
}

document.addEventListener("DOMContentLoaded", app);